"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DefaultLayoutPage = require("./DefaultLayoutPage");
Object.keys(_DefaultLayoutPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DefaultLayoutPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DefaultLayoutPage[key];
    }
  });
});
var _DefaultLayoutFeature = require("./DefaultLayoutFeature");
Object.keys(_DefaultLayoutFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DefaultLayoutFeature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DefaultLayoutFeature[key];
    }
  });
});
var _prepareDefaultLayoutPageProps = require("./prepareDefaultLayoutPageProps");
Object.keys(_prepareDefaultLayoutPageProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _prepareDefaultLayoutPageProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _prepareDefaultLayoutPageProps[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _translations = require("./translations");
Object.keys(_translations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _translations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _translations[key];
    }
  });
});
